import { render, staticRenderFns } from "./ItemPipe.vue?vue&type=template&id=05df487e&scoped=true&"
import script from "./ItemPipe.vue?vue&type=script&lang=js&"
export * from "./ItemPipe.vue?vue&type=script&lang=js&"
import style0 from "./ItemPipe.vue?vue&type=style&index=0&id=05df487e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df487e",
  null
  
)

export default component.exports